import { loader } from 'graphql.macro'

export default async function addAssetToJob ({ dataLoaders, variables }) {
  const schema = loader('./addAssetToJob.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, {
    input: {
      assetId: variables.assetId,
      jobId: variables.jobId
    }
  })
  return response.addAssetToJob
}
